import { useEffect, useState } from "react";
import { Form } from "reactstrap";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../../../config/apisd";

const FIELDS = [
  { name: "bobot_asts", label: "Bobot ASTS" },
  { name: "bobot_asas", label: "Bobot ASAS" },
  { name: "bobot_sumatif_harian", label: "Bobot Sumatif Harian" },
  { name: "bobot_sumatif_akhir", label: "Bobot Sumatif Akhir" },
];

const getAdminId = () => {
  const storedId = localStorage.getItem("id_admin");

  if (!storedId) {
    return null;
  }

  try {
    return JSON.parse(storedId);
  } catch {
    return storedId;
  }
};

export default function ModalBobotUpdate(props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [form, setForm] = useState({
    bobot_asts: "",
    bobot_asas: "",
    bobot_sumatif_harian: "",
    bobot_sumatif_akhir: "",
  });

  useEffect(() => {
    const getValue = (key) => {
      const value = (props.currentData || []).find(
        (item) => item.key === key
      )?.bobot;

      if (value === undefined || value === null) {
        return "";
      }

      // Memastikan angka pecahan ditampilkan menggunakan titik.
      return String(value).replace(/,/g, ".");
    };

    setForm({
      bobot_asts: getValue("bobot_asts"),
      bobot_asas: getValue("bobot_asas"),
      bobot_sumatif_harian: getValue("bobot_sumatif_harian"),
      bobot_sumatif_akhir: getValue("bobot_sumatif_akhir"),
    });
  }, [props.currentData]);

  const handleChange = ({ target: { name, value } }) => {
    // Hanya menerima angka dan satu titik desimal.
    if (!/^\d*(\.\d*)?$/.test(value)) {
      return;
    }

    setForm((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const preventComma = (event) => {
    if (event.key === ",") {
      event.preventDefault();

      ToastError.fire({
        icon: "error",
        title: "Gunakan titik (.) untuk angka desimal",
      });
    }
  };

  const preventCommaPaste = (event) => {
    const pastedValue = event.clipboardData.getData("text");

    if (pastedValue.includes(",")) {
      event.preventDefault();

      ToastError.fire({
        icon: "error",
        title: "Gunakan titik (.) untuk angka desimal",
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const invalid = FIELDS.some(({ name }) => {
      const value = form[name];
      const numericValue = Number(value);

      return (
        value === "" ||
        value === "." ||
        !Number.isFinite(numericValue) ||
        numericValue < 0 ||
        numericValue > 100
      );
    });

    if (invalid) {
      ToastError.fire({
        icon: "error",
        title:
          "Semua bobot wajib diisi dengan nilai 0-100 menggunakan titik untuk desimal",
      });

      return;
    }

    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("token");
      const updateBy = getAdminId();
      const recordId = props.currentData?.[0]?.record_id;

      if (!recordId) {
        throw new Error("ID data bobot tidak ditemukan");
      }

      await APISD.put(
        `/api/standar-calculation/update/${recordId}`,
        {
          ysb_academic_year_id:
            props.filterData.ysb_academic_year_id,
          ysb_semester_id:
            props.filterData.ysb_semester_id,
          ysb_branch_id:
            props.filterData.ysb_branch_id,
          ysb_school_id:
            props.filterData.ysb_school_id,
          bobot_asts: Number(form.bobot_asts),
          bobot_asas: Number(form.bobot_asas),
          bobot_sumatif_harian: Number(
            form.bobot_sumatif_harian
          ),
          bobot_sumatif_akhir: Number(
            form.bobot_sumatif_akhir
          ),
          update_by: updateBy,
        },
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      await props.GetResponseData();

      ToastSuccess.fire({
        icon: "success",
        title: "Semua data bobot berhasil diperbarui",
      });

      props.onHide();
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          error?.message ||
          "Gagal memperbarui data bobot",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-bobot"
    >
      <div className="sims-modal-header">
        <div>
          <h5
            id="modal-update-bobot"
            className="sims-modal-title"
          >
            Update Bobot
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="sims-modal-body">
          <div className="bobot-filter-info">
            <div className="bobot-filter-info-item">
              <span className="bobot-filter-info-label">
                Tahun Ajaran
              </span>

              <span className="bobot-filter-info-value">
                {props.filterLabels?.academicYear || "-"}
              </span>
            </div>

            <div className="bobot-filter-info-item">
              <span className="bobot-filter-info-label">
                Cabang
              </span>

              <span className="bobot-filter-info-value">
                {props.filterLabels?.branch || "-"}
              </span>
            </div>

            <div className="bobot-filter-info-item">
              <span className="bobot-filter-info-label">
                Sekolah
              </span>

              <span className="bobot-filter-info-value">
                {props.filterLabels?.school || "-"}
              </span>
            </div>
          </div>

          <div className="bobot-fields-grid">
            {FIELDS.map(({ name, label }) => (
              <div
                className="sims-form-group"
                key={name}
              >
                <label
                  className="sims-form-label"
                  htmlFor={`${name}_update`}
                >
                  {label} <span>*</span>
                </label>

                <input
                  id={`${name}_update`}
                  className="sims-form-input"
                  required
                  type="text"
                  inputMode="decimal"
                  name={name}
                  pattern="[0-9]+([.][0-9]+)?"
                  placeholder="Contoh: 50.50"
                  onKeyDown={preventComma}
                  onPaste={preventCommaPaste}
                  onChange={handleChange}
                  value={form[name]}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            <FontAwesomeIcon icon={faFloppyDisk} />

            {isSubmitting
              ? " Memperbarui..."
              : " Update"}
          </button>
        </div>
      </Form>
    </Modal>
  );
}